import React, { useEffect, useMemo } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import PopupMask from "@/componentsUI/PopupMask";
import { getCurrentInstallLink } from "@/utils/countryConfigUtils";
import type { ClientEnvironment } from "@/features/clientEnv";
import { openInstallLinkWithApkTransfer } from "@/features/install/apkTransfer";
import { INSTALL_TRACK_SOURCES } from "@/features/analytics/em/events";
import { trackEmEvent } from "@/features/analytics/em/sdk";
import MarketingImagePopup from "@/features/common/marketingPopup";
import { getInstallAfterAuthPromptBannerImage } from "./bannerImage";

import styles from "./InstallAfterAuthPrompt.module.less";

type Props = {
  env?: ClientEnvironment;
};

const InstallAfterAuthPromptModal = NiceModal.create((props: Props) => {
  const { visible, resolve, remove } = useModal();

  const installLink = useMemo(() => getCurrentInstallLink(), []);

  const bannerImage = getInstallAfterAuthPromptBannerImage(props.env);

  useEffect(() => {
    if (visible) {
      trackEmEvent("apk_post_auth_prompt_view", {
        source: INSTALL_TRACK_SOURCES.POST_AUTH_INSTALL_PROMPT,
      });
    }
  }, [visible]);

  const handleClose = () => {
    resolve();
    remove();
  };

  const handleDownload = () => {
    trackEmEvent("apk_post_auth_prompt_click", {
      source: INSTALL_TRACK_SOURCES.POST_AUTH_INSTALL_PROMPT,
    });
    if (installLink) {
      void openInstallLinkWithApkTransfer(installLink, {
        source: INSTALL_TRACK_SOURCES.POST_AUTH_INSTALL_PROMPT,
        fromRegisterFlow: true,
      });
    }
    resolve();
    remove();
  };

  return (
    <PopupMask visible={visible}>
      <MarketingImagePopup
        imageSrc={bannerImage}
        imageAlt="Download App"
        onImageClick={handleDownload}
        onClose={handleClose}
        imageClassName={styles.bannerImage}
      />
    </PopupMask>
  );
});

export default InstallAfterAuthPromptModal;
